import { HTMLAttributes } from 'react';
import { cx } from '../util';

export type ClarionCardProps = HTMLAttributes<HTMLDivElement> & {
  elevation?: 0 | 1 | 2 | 3 | 4;
  compact?: boolean;
};

// Increase brightness to indicate elevation in dark mode
const elevationClasses = {
  0: 'shadow-none dark:bg-gray-800',
  1: 'shadow-sm dark:bg-gray-700/20',
  2: 'shadow-md dark:bg-gray-700/40',
  3: 'shadow-lg dark:bg-gray-700/60',
  4: 'shadow-xl dark:bg-gray-700/80',
};

export function ClarionCard({
  elevation = 0,
  compact = false,
  className,
  ...props
}: ClarionCardProps) {
  return (
    <div
      className={cx(
        'bg-white rounded-lg border border-gray-200 dark:border-gray-700',
        elevationClasses[elevation],
        compact ? 'p-3' : 'p-5',
        className,
      )}
      {...props}
    />
  );
}
